import { I18nMessages } from "../../../i18n/i18n";

const returnAndDeliveryFeatures = [
  { label: I18nMessages.PRODUCT_DELIVERY, value: I18nMessages.PRODUCT_DELIVERY_VALUE },
  { label: I18nMessages.PRODUCT_RETURN, value: I18nMessages.PRODUCT_RETURN_VALUE },
  { label: I18nMessages.PRODUCT_EASY_RETURN, value: I18nMessages.PRODUCT_EASY_RETURN_VALUE },
  { label: I18nMessages.PRODUCT_RETURN_GUIDE, value: I18nMessages.PRODUCT_RETURN_GUIDE_VALUE },
  { label: I18nMessages.PRODUCT_REFUND, value: I18nMessages.PRODUCT_REFUND_VALUE },
];

const IMAGE_CDN_WIDTH = 600;

export { returnAndDeliveryFeatures, IMAGE_CDN_WIDTH };
